import { z } from "zod";

// Campos escalares del formulario de perfil (SPEC-216 §3). La matriz de
// permisos NO se modela acá: son siete filas con reglas de coherencia
// cruzada (§4) que no encajan bien en `register` de un solo campo — se
// gestiona como estado propio en ProfileForm (permissionMatrix.ts), igual
// de explícito, y se combina con estos valores recién al enviar.
export const profileFormSchema = z.object({
  name: z.string().trim().min(1, "El nombre del perfil es obligatorio"),
  description: z.string(),
  validatorOnly: z.boolean(),
});
export type ProfileFormValues = z.infer<typeof profileFormSchema>;

// Mismo criterio que `CATALOG_ENTRY_FORM_FIELDS`/`MEMBER_FORM_FIELDS`: la
// lista de claves que `ProfileForm` realmente renderiza, para que
// `applyApiFieldErrors` sepa asociar `PROFILE_DUPLICATE` (`name`) y qué otros
// campos caen al toast genérico.
export const PROFILE_FORM_FIELDS = Object.keys(
  profileFormSchema.shape,
) as readonly (keyof ProfileFormValues)[];
